export const TIMESERIES_METRIC_REVENUE = 'revenue';
export const TIMESERIES_METRIC_REVENUE_IN_LOCAL_CURRENCY = 'revenue_in_local_currency';
export const TIMESERIES_METRIC_COST = 'cost';
export const TIMESERIES_METRIC_COST_IN_APP_LOCAL_CURRENCY = 'cost_in_app_local_currency';
export const TIMESERIES_METRIC_PERCENTAGE = 'percentage';
export const TIMESERIES_METRIC_UNIQUE_COUNT = 'unique_count';
export const TIMESERIES_METRIC_TOTAL_COUNT = 'total_count';

export const TIMESERIES_LABEL_RETURN_PERCENTAGE = '% Return';
export const TIMESERIES_LABEL_AMOUNT = 'Amount';
export const TIMESERIES_LABEL_AMOUNT_IN_LOCAL_CURRENCY = 'Amount in Local Currency';
export const TIMESERIES_LABEL_COUNT = 'Count';
